const EnterToConfirmMixin = {
  mounted() {
    this._handleEnter = e => {
      if (e.keyCode == 13) {
        if (typeof this.confirm === 'function') {
          e.preventDefault()
          this.confirm()
        } else {
          console.error('confirm method not defined for escape to confirm mixin')
        }
      }
    }
    window.addEventListener('keydown', this._handleEnter)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this._handleEnter)
  },
}

export default EnterToConfirmMixin
